export class NotLoggedIn extends Error {
  message = 'User is not logged in';
}
